/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TickerLotDto } from '../../models/ticker-lot-dto';

export interface GetTickerLot$Params {
  id: number;
  'X-API-Version'?: string;
}

export function getTickerLot(http: HttpClient, rootUrl: string, params: GetTickerLot$Params, context?: HttpContext): Observable<StrictHttpResponse<TickerLotDto>> {
  const rb = new RequestBuilder(rootUrl, getTickerLot.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TickerLotDto>;
    })
  );
}

getTickerLot.PATH = '/api/ticker/lots/{id}';
